import {
  ArrowTrendingDownIcon,
  BellAlertIcon,
  BookmarkIcon,
  CalendarIcon,
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  FolderOpenIcon,
  HandThumbUpIcon,
  LockClosedIcon,
  TrophyIcon
} from "@heroicons/react/24/outline";
import { IconButton, Typography } from "@material-tailwind/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ImageOrInitials from "../../Components/Functionality/ImageOrInitials";
import ProfileLinkCard from "../../Components/UI/Cards/ProfileLinkCard";
import { useUserProfileStore } from "../../Context/store";
import { useTab } from "../../Context/TabContext";

const ProfileDetailsV1 = ({ closeDrawerRight, setIsEdit, enabled }) => {
  const location = useLocation();
  const { setTab } = useTab();
  const { profileDetail: profileDetails } = useUserProfileStore();
  const navigate = useNavigate();
  const ProfileDataSections = [
    {
      Title: "MY ACTIVITY",
      SubOptions: [
        {
          name: "Active",
          link: "/profile/active-drafts?selected=active",
          icon: <ChatBubbleLeftRightIcon />,
          description: "Debates you're participating in",
          count: profileDetails?.activeDebateCount || 0,
        },
        {
          name: "Pending Invitations",
          link: "/notification",
          icon: <BellAlertIcon />,
          description: "Invites waiting for your response",
          count: profileDetails?.inviteDebateCount || 0,
        },
        {
          name: "Voted",
          link: "/voted",
          icon: <HandThumbUpIcon />,
          description: "Debates you've voted on",
          count: profileDetails?.votedDebateCount || 0,
        },
      ],
    },
    {
      Title: "MY DEBATES",
      SubOptions: [
        {
          name: "Open Debate",
          link: "/profile/open-debate",
          icon: <FolderOpenIcon />,
          description: "Public and forum debates",
          count: profileDetails?.openDebateCount || 0,
        },
        {
          name: "Participated",
          link: "/debated",
          icon: <ChatBubbleLeftRightIcon />,
          description: "All debates you've joined",
          count: profileDetails?.participatedDebateCount || 0,
        },
        {
          name: "Private",
          link: "/private",
          icon: <LockClosedIcon />,
          description: "Private debates",
          count: profileDetails?.privateDebateCount || 0,
        },
        {
          name: "My Drafts",
          link: "/profile/active-drafts?selected=draft",
          icon: <DocumentTextIcon />,
          description: "Unpublished debates drafts",
          count: profileDetails?.draftDebateCount || 0,
        },
        {
          name: "Won",
          link: "/profile/debate-result?selected=won",
          icon: <TrophyIcon />,
          description: "Debates you've won",
          count: profileDetails?.wonDebateCount || 0,
        },
        {
          name: "Lost",
          link: "/profile/debate-result?selected=loss",
          icon: <ArrowTrendingDownIcon />,
          description: "Debates you've lost",
          count: profileDetails?.lossDebateCount || 0,
        },
      ],
    },
    {
      Title: "SAVED",
      SubOptions: [
        {
          name: "Saved",
          link: "/profile/mysave",
          icon: <BookmarkIcon />,
          description: "Bookmarked debates",
          count: profileDetails?.mySavedDebateCount || 0,
        },
      ],
    },
  ];

  const handleNavigate = (link) => {
    if (enabled) {
      closeDrawerRight();
    }
    if (link.includes("notification")) {
      setTab("nomination");
    }
    navigate(link);
  };

  return (
    <div className="w-full h-full flex flex-col">
      <div className="px-4 h-10 flex items-center justify-between ">
        <Typography variant="h4" color="blue-gray">
          Profile
        </Typography>
        <IconButton variant="text" color="blue-gray" onClick={closeDrawerRight}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </IconButton>
      </div>
      <hr className="border-debatePalette-hr" />
      <div className=" px-4 border-debatePalette-bodyText flex flex-col py-4 gap-2 items-center  relative">
        <p
          className="text-debatePalette-shadow absolute top-2 right-2 cursor-pointer"
          onClick={setIsEdit}
        >
          Edit
        </p>
        <ImageOrInitials
          imageSrc={profileDetails?.userImage}
          alt={profileDetails?.email}
          initials={profileDetails?.userName || profileDetails?.email}
          size={"h-16 w-16"}
          classNameInitials={"text-xl"}
        />
        {/* <p>{profileDetails?.userName}</p> */}
      </div>
      <div className="flex flex-col gap-2 flex-1 overflow-hidden">
        <hr className="border-debatePalette-hr" />
        <div className=" px-4 border-debatePalette-bodyText flex flex-col justify-center gap-2">
          <Typography className="text-debatePalette-title font-normal">
            Contact Information
          </Typography>
          <div className="flex gap-2 items-center">
            <EnvelopeIcon className="w-4 h-4" />
            <div className="flex flex-col ">
              <a href="/" className="text-debatePalette-title text-xs">
                {profileDetails?.email}
              </a>
            </div>
          </div>
          <div className="flex gap-2 items-center">
            <CalendarIcon className="w-4 h-4" />
            <div className="flex flex-col ">
              <a href="/" className="text-debatePalette-title text-xs">
                {profileDetails?.joinDate}
              </a>
            </div>
          </div>
        </div>
        <hr className="border-debatePalette-hr" />
        <div className=" px-4 flex flex-col justify-center gap-2">
          <div
            className="flex justify-around items-center"
            onClick={closeDrawerRight}
          >
            <Link
              to={"/profile/follower-management?selected=followings"}
              className="text-debatePalette-title p-1 rounded-md hover:bg-blue-gray-50 flex flex-col gap-1 items-center justify-center"
              state={{ prevPath: location?.pathname }}
            >
              <span className="text-debatePalette-title">
                {profileDetails?.followingUserCount}
              </span>
              <span className="text-debatePalette-buttonBorder">Following</span>
            </Link>
            <div className="w-px h-8 bg-debatePalette-hr"></div>
            <Link
              to={"/profile/follower-management?selected=followers"}
              className="text-debatePalette-title p-1 rounded-md hover:bg-blue-gray-50 flex flex-col gap-1 items-center justify-center"
              state={{ prevPath: location?.pathname }}
            >
              <span className="text-debatePalette-title">
                {profileDetails?.followerUserCount}
              </span>
              <span className="text-debatePalette-buttonBorder">Followers</span>
            </Link>
          </div>
        </div>
        <hr className="border-debatePalette-hr" />
        <div className="px-4 border-debatePalette-bodyText flex flex-col justify-start overflow-y-auto flex-1">
          {ProfileDataSections.map((section) => (
            <div key={section.Title} className="mb-4">
              <Typography className="text-debatePalette-buttonBorder font-semibold text-sm mb-2">
                {section.Title}
              </Typography>
              <hr className="border-debatePalette-hr" />
              {section.SubOptions.map((option) => (
                <ProfileLinkCard
                  key={option.name}
                  title={option.name}
                  subtitle={option.description}
                  rightText={option?.count}
                  showChevron={true}
                  icon={option.icon}
                  onClick={() => handleNavigate(option.link)}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileDetailsV1;
